var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('DashboardMobile'):_c('v-container',{staticClass:"px-5 grey lighten-5",attrs:{"fluid":""}},[(_vm.hasDivision(['Corporate']))?_c('dashboard-corporate'):_vm._e(),(_vm.hasDivision(['Field']))?_c('dashboard-field'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }